export const CAROUSEL_HTML_MARKER = "SearchBubble Carousel - Email Static Snapshot";
export const EMBED_PLACEHOLDER_TEXT =
  "[Carousel embed pasted. Preview will show the live carousel block.]";
export const EMBED_PLACEHOLDER_HTML = `<p data-sb-email-embed-placeholder="true">${EMBED_PLACEHOLDER_TEXT}</p>`;
